import ApiCore from '../../../services/api/utilities/core'
import apiProvider from '../../../services/api/utilities/provider'

const url = 'firebase'

const apiFirebaseAuth = new ApiCore({
  getAll: true,
  getSingle: true,
  post: false,
  put: false,
  patch: false,
  delete: false,
  url,
})

apiFirebaseAuth.getCustomToken = (uid) =>
  apiProvider.getSingle(
    url,
    `login-token?api_key=${import.meta.env.VITE_SECRET_KEY}&uid=${uid}`,
  )

export default apiFirebaseAuth
